import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";

// Importa imágenes de los vehículos
import cadillacXTS from "../assets/images/Cadillac XTS.png";
import lincolnMKT from "../assets/images/Lincoln MKT.png";
import cadillacEscalade from "../assets/images/Cadillac Escalade.png";
import mercedesSprinter from "../assets/images/Mercedes Sprinter.png";

// Datos de la flota
const fleetVehicles = [
  {
    id: 1,
    title: "Cadillac XTS",
    passengers: 4,
    description:
      "Experience the refined style of the Cadillac XTS, ideal for local trips and airport transfers.",
    image: cadillacXTS,
  },
  {
    id: 2,
    title: "Lincoln MKT",
    passengers: 5,
    description:
      "Ride in style with the Lincoln MKT, offering comfort and elegance for every journey.",
    image: lincolnMKT,
  },
  {
    id: 3,
    title: "Cadillac Escalade",
    passengers: 7,
    description:
      "The Cadillac Escalade provides unmatched luxury and spacious interiors for a premium experience.",
    image: cadillacEscalade,
  },
  {
    id: 4,
    title: "Mercedes Sprinter",
    passengers: 15,
    description:
      "Perfect for group travels and special events, the Mercedes Sprinter offers plenty of space and top safety features.",
    image: mercedesSprinter,
  },
];

// Efecto "slide up" al montar el componente
function fadeUp(show) {
  return {
    opacity: show ? 1 : 0,
    transform: show ? "translateY(0)" : "translateY(100px)",
    transition: "opacity 1s ease, transform 1s ease",
  };
}

export default function FleetPage() {
  const navigate = useNavigate();

  // Hover en cada tarjeta
  const [hoveredCard, setHoveredCard] = useState(null);
  // Control de la animación (aparecer desde abajo)
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    setShowContent(true);
  }, []);

  const handleQuoteClick = () => {
    navigate("/reservation");
  };

  return (
    <div style={{ ...styles.pageContainer, ...fadeUp(showContent) }}>
      {/* Título y descripción */}
      <div style={styles.descriptionBar}>
        <h2 style={styles.descriptionTitle}>FLEET AT HERITAGE CAR AIRPORT</h2>
        <p style={styles.descriptionText}>
          Heritage Car Airport delivers premium, reliable transportation services
          for local trips and airport transfers. Our fleet is continuously updated,
          ensuring every vehicle is clean, luxurious, and safe.
        </p>
      </div>

      {/* Contenedor que deja 1 cm a la izquierda y 1 cm a la derecha */}
      <div style={styles.gridContainer}>
        {/* Grid de 4 columnas fijas */}
        <div style={styles.fleetGrid}>
          {fleetVehicles.map((vehicle) => (
            <div key={vehicle.id} style={styles.card}>
              {/* Franja superior */}
              <div style={styles.topStripe}>
                <span style={styles.cardTitle}>{vehicle.title}</span>
                <div style={styles.passengerInfo}>
                  <FaUser style={{ marginRight: 5 }} />
                  <span>{vehicle.passengers}</span>
                </div>
              </div>

              {/* Imagen con capa hover */}
              <div
                style={styles.imageContainer}
                onMouseEnter={() => setHoveredCard(vehicle.id)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <img
                  src={vehicle.image}
                  alt={vehicle.title}
                  style={styles.cardImage}
                />
                <div
                  style={{
                    ...styles.hoverOverlay,
                    opacity: hoveredCard === vehicle.id ? 1 : 0,
                  }}
                >
                  <div style={styles.overlayContent}>
                    <span>{vehicle.title}</span>
                    <br />
                    <span>9142762961</span>
                  </div>
                </div>
              </div>

              {/* Descripción */}
              <div style={styles.cardBody}>
                <p style={styles.description}>{vehicle.description}</p>
              </div>

              {/* Botón */}
              <button style={styles.quoteButton} onClick={handleQuoteClick}>
                GET A QUOTE NOW!
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Estilos en línea
const styles = {
  pageContainer: {
    // Ocupa todo el ancho, y centrado con auto
    width: "100%",
    margin: "0 auto",
    backgroundColor: "#f5f5f5",
    // 600px arriba, 0 en los lados, 50px abajo
    padding: "600px 0 50px",
    display: "flex",
    flexDirection: "column",
    gap: "60px",
    minHeight: "auto",
  },
  descriptionBar: {
    textAlign: "center",
    marginBottom: "30px",
    padding: "10px 20px",
  },
  descriptionTitle: {
    fontSize: "3rem",
    fontWeight: "bold",
    color: "#203a43",
    textTransform: "uppercase",
    marginBottom: "15px",
  },
  descriptionText: {
    fontSize: "1.2rem",
    lineHeight: 1.6,
    maxWidth: "900px",
    margin: "auto",
    color: "#2B3F50",
  },
  // 🔸 Margin horizontal de 1 cm a cada lado (izquierda y derecha)
  gridContainer: {
    margin: "0 1cm",
  },
  // Grid de 4 columnas fijas
  fleetGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "40px",
    marginTop: "0px",
    width: "100%",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  topStripe: {
    height: "60px",
    background: "linear-gradient(to right, #161616, #2B3F50)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 15px",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
  },
  cardTitle: {
    fontSize: "1rem",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  passengerInfo: {
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: "1rem",
  },
  imageContainer: {
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
  },
  cardImage: {
    width: "100%",
    height: "240px",
    objectFit: "cover",
  },
  hoverOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(15, 22, 36, 0.7)",
    opacity: 0,
    transition: "opacity 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    textAlign: "center",
    fontSize: "1.4rem",
    fontWeight: "bold",
  },
  overlayContent: {
    fontFamily: "'Helvetica Neue', sans-serif",
    textTransform: "uppercase",
  },
  cardBody: {
    padding: "25px",
    flex: 1,
  },
  description: {
    fontSize: "1rem",
    color: "#555",
    lineHeight: "1.5",
  },
  quoteButton: {
    backgroundColor: "#0066cc",
    color: "#fff",
    padding: "14px 18px",
    borderRadius: "10px",
    cursor: "pointer",
    fontSize: "1.1rem",
    margin: "25px",
    border: "none",
  },
};
